import React from 'react';
import styled, { keyframes } from 'styled-components';
import SectionNumber from './SectionNumber';

const IntroSection = styled.section`
  min-height: calc(100svh - 100px);
  padding: 100px 0;
  position: relative;
  background: ${props => props.theme.colors.terracotta};
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('/assets/patterns/Contours - clipped (orange).svg');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    opacity: 1;
    z-index: 1;
  }
`;

const IntroContent = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.spacing.xl};
  max-width: 1000px;
  padding: 0 ${props => props.theme.spacing.lg};
`;

const IntroHeading = styled.h2`
  font-family: ${props => props.theme.typography.heading.fontFamily};
  font-weight: ${props => props.theme.typography.heading.fontWeight};
  font-size: 3.5rem;
  line-height: 1.1;
  color: ${props => props.theme.colors.bone};
  margin: 0;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    font-size: 2.5rem;
  }
`;

const IntroHighlight = styled.p`
  font-family: ${props => props.theme.typography.highlight.fontFamily};
  font-weight: ${props => props.theme.typography.highlight.fontWeight};
  font-style: ${props => props.theme.typography.highlight.fontStyle};
  font-size: 3.5rem;
  line-height: 1.3;
  color: ${props => props.theme.colors.bone};
  margin: 0;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    font-size: 2.5rem;
  }
`;

const IntroBodyText = styled.p`
  color: ${props => props.theme.colors.bone};
  font-weight: 400;
  margin: ${props => props.theme.spacing.md} 0 0 0;
  font-size: ${props => props.theme.typography.sizes.bodyLarge};
  font-family: ${props => props.theme.typography.body.fontFamily};
`;

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`;

const DownArrow = styled.div`
  margin-top: ${props => props.theme.spacing.lg};
  animation: ${bounce} 2s infinite;
  font-size: 2rem;
  color: ${props => props.theme.colors.bone};
`;

const MethodologyIntro = () => {
  return (
    <IntroSection id="methodology">
      <IntroContent>
        <IntroHeading>Your innovation is complex.</IntroHeading>
        <IntroHighlight>Your pitch shouldn't be.</IntroHighlight>
        <IntroBodyText>Here's how we make investors finally understand what you've built
        </IntroBodyText>
        <DownArrow>↓</DownArrow>
      </IntroContent>
      <SectionNumber number={3} />
    </IntroSection>
  );
};

export default MethodologyIntro;
